import React, { useState, useEffect } from "react";
import { collection, doc, getDoc, getDocs, updateDoc,arrayUnion } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { RiDeleteBinLine } from "react-icons/ri";
import { getImage } from "../../utils/ProductStatus";
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import loader from "../../assets/loader-imagine.gif";
import RetailerCard from "../../components/RetailerCard"; 
import Invoice from "../../components/Invoice/Invoice";
import { addBill } from "../../network/api/endpoints";

import InvoiceModel from "../../network/models/Invoice";
import { useDistributor } from "../../hooks/useDistributor";
import useUserInventory from "../../hooks/useUserInventory";


function DistributorBilling() {
  const [queryText, setQueryText] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [addedItems, setAddedItems] = useState([]);
  const [error, setError] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [showRetailer, setShowRetailer] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const { inventory, loading: inventoryLoading, error: inventoryError } = useUserInventory();



  // Function to validate serial number format
  const validateSerialNumber = (serialNumber) =>
    /^IMG\d{9}$/.test(serialNumber);

  const searchAndAdd = async () => {
    if (!validateSerialNumber(queryText.trim())) {
      setError(
        "Invalid serial number format. Expected format: IMG followed by 9 digits."
      );
      setLoading(false);
      return;
    }

    const serialNumber = queryText.trim();

    const isAlreadyAdded = addedItems.some((item) => item.serialNumber === serialNumber);
    if (isAlreadyAdded) {
      setError("Item is already added to the list.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const productInInventory = inventory.find((item) => item.serialNumber === serialNumber);

      if (!productInInventory) {
        setError("Item not available in your inventory.");
        return;
      }

      const docRef = doc(db, "all-products", serialNumber);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = { id: docSnap.id, ...docSnap.data() };
        setAddedItems((prevItems) => [...prevItems, data]);
        setTotalPrice((prevTotal) => prevTotal + Number(data.retailerPrice));
        setQueryText("");
      } else {
        setError("Item not available");
      }
    } catch (error) {
      setError("Failed to fetch item details. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (queryText.trim()) {
      setLoading(true);
      searchAndAdd();
    } // Cleanup the timeout on each re-render
  }, [queryText]);

  const handleChange = (e) => {
    setQueryText(e.target.value);

    setError("");
  };

  const removeHandler = (index) => {
    setAddedItems((prevItems) => {
      const newItems = [...prevItems];
      newItems.splice(index, 1);
      return newItems;
    });
  };

  useEffect(() => {
    setTotalPrice(
      addedItems.reduce((acc, curr) => acc + Number(curr.retailerPrice), 0)
    );
  }, [addedItems]);

  const [search, setSearch] = useState(""); // Search state
  const [selectedUser, setSelectedUser] = useState("retailer");
  const [selectedBilledUser, setSelectedBilledUser] = useState(null);
  const [retailers, setRetailers] = useState([]);
  // const [distributor, setDistributors] = useState([]);
  const [filteredRetailers, setfilteredRetailers] = useState([]);
  // const [filteredDistributors, setfilteredDistributors] = useState([]);



  const currentDistributor = useDistributor();
  useEffect(() => {
    const lowerCaseSearch = search.toLowerCase();
  
    if (currentDistributor) {
      const results = retailers.filter((retailer) => {
        return (
          retailer.name.toLowerCase().includes(lowerCaseSearch) ||
          retailer.email.toLowerCase().includes(lowerCaseSearch) ||
          retailer.userName.toLowerCase().includes(lowerCaseSearch) ||
          retailer.mobile.includes(lowerCaseSearch)
        );
      });
  
      setfilteredRetailers(results);
    }
  }, [search, retailers]);
  

  const handleFinalSubmit = async (billedData) => {
    setLoading(true);
    try {
      const transactionDetails = await addBill(billedData);
      
      await updateSoldItems(billedData.serialNumbers);

      setAddedItems([]);
      showInvoice(transactionDetails);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  
  const distributor  = useDistributor();

const updateSoldItems = async (serialNumbers) => {
  if (!distributor) {
    console.error("Distributor not found.");
    return;
  }

  try {
    const distributorRef = doc(db, "users", distributor.uid);
    const distributorSnap = await getDoc(distributorRef);

    if (distributorSnap.exists()) {
      // Update Firestore
      await updateDoc(distributorRef, {
        soldItems: arrayUnion(...serialNumbers),
      });

      // Update local session
      const updatedDistributor = {
        ...distributor,
        soldItems: [...(distributor.soldItems || []), ...serialNumbers],
      };
      localStorage.setItem("distributor", JSON.stringify(updatedDistributor));
    } else {
      console.error("Distributor record not found in Firestore.");
    }
  } catch (error) {
    console.error("Failed to update sold items:", error);
  }
};





  const [invoiceData, setInvoiceData] = useState(null);
  function isFourthCharacterR(inputString) {
    // Check if the input string has at least 4 characters
    if (inputString.length < 4) {
      return false; // Not enough characters
    }
    
    // Check if the fourth character is 'R'
    return inputString[3] === 'R';
  }

  const showInvoice = (transactionDetails) => {
    const isB2B = isFourthCharacterR(transactionDetails.transactionId);

    const invoice = new InvoiceModel({
      id: transactionDetails.transactionId,
      date: new Date().toDateString() ,
      type: isB2B ? "B2B" : "B2C",
      customerDetail: {
        name: selectedBilledUser.name,
        email: selectedBilledUser.email,
        mobile: selectedBilledUser.mobile,
      },
      products: addedItems,
    });
    setInvoiceData(invoice); // Set the invoice data
    setShowDialog(true); // Show the dialog
  };

  const handleCloseDialog = () => {
    setShowDialog(false); // Close the dialog
  };

  const fetchRetailers = async () => {
    setLoading(true);
    try {
      const inventorySnapshot = await getDocs(collection(db, "users"));
      const inventoryList = inventorySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const categorizedUsers = inventoryList.reduce(
        (acc, user) => {
          const role = user.role.toLowerCase();
          if (role === "retailer") {
            acc.retailers.push(user);
          } else if (role === "distributor") {
            acc.distributors.push(user);
          }
          return acc;
        },
        { retailers: [], distributors: [] }
      );


      setRetailers(categorizedUsers.retailers);
      // setfilteredDistributors(categorizedUsers.distributors);
    } catch (err) {
      setError("Failed to fetch retailers. Please try again later.");

    } finally {
      setLoading(false);
    }
  };

  const user=useDistributor();

  const handleSelectUser = async () => {
    if (!showRetailer) {
      // Show retailer and fetch retailers
      setShowRetailer(true);
      await fetchRetailers();
    } else {

      const serials = addedItems.map((serialNumber) => serialNumber.id)
      const billingDetails  = {
        from: 'distributor',
        fromDistributorId:user.uid ,
        to: selectedBilledUser.role.toLowerCase(),
        toEntityId: selectedBilledUser.id,
        isRegistered: true,
        bill: totalPrice,
        serialNumbers: serials,
      };

      await handleFinalSubmit(billingDetails)

    }
  };

  // JSX for the button
  <button
    onClick={handleSelectUser}
    className="w-full mt-10 bg-red-700 hover:bg-red-900 py-2"
  >
    <span className="text-white">
      {!showRetailer ? "Choose Retailer/Distributor" : "Checkout"}
    </span>
  </button>;

  const handleChangeRetailer = (type) => () => {
    setSelectedUser(type);
  };

  return (
    <>
      <div className="flex flex-col">
        <div>
          <input
            className="w-full p-3 my-6 text-black"
            type="text"
            placeholder="Serial Number"
            value={queryText}
            autoFocus={true}
            onChange={handleChange}
          />
          <h1 className="text-xl border-b mb-4 pb-4 text-left">
            Total Items : {addedItems.length}
          </h1>
          {error && <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>}
        </div>
        {/* Display validation error */}
        {isLoading ? (
          <img src={loader} alt="loading" className="w-1/4 self-center" />
        ) : (
          <div className="flex flex-row">
            <main className="overflow-auto flex-auto mr-10 mt-0">
              <div className="min-h-40 max-h-[700px] ">
                {addedItems.length > 0 ? (
                  addedItems.map((i, idx) => (
                    <CartItemCard
                      key={idx}
                      cartItem={i}
                      index={idx}
                      removeHandler={removeHandler}
                    />
                  ))
                ) : (
                  <h1>Cart is Empty</h1>
                )}
              </div>
            </main>

            <aside className=" flex-auto mt-5">
              <h1 className="text-xl border-b mb-4 pb-4 text-left">Summary</h1>
              <div className="flex pb-2">
                <h2 className="mr-auto">Subtotal</h2>
                <h2 className="ml-auto">₹{totalPrice}</h2>
              </div>
              <div className="flex pb-2">
                <h1 className="mr-auto">Discount</h1>
                <span className="ml-auto">₹{0}</span>
              </div>

              <div className="flex pt-4 pb-6">
                <h1 className="mr-auto">Total:</h1>
                <h1 className="ml-auto">₹{totalPrice}</h1>
              </div>
              <div></div>
              {showRetailer && (
                <div className="flex w-full flex-col items-center justify-center mt-10">
                  <RetailerCard handleChange={handleChangeRetailer} />

                  <Card className="bg-white p-4 w-full">
                    {/* Search Bar */}
                    <div className="mb-4">
                      <input
                        type="text"
                        placeholder="Search by name, username, or mobile"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded"
                      />
                    </div>

                    {/* User List */}
                    <div className="list h-64 overflow-y-scroll border-t border-gray-300">
                      <ul className="divide-y divide-gray-300">
                        {selectedUser.toLowerCase() === "retailer" ? (
                          filteredRetailers.length > 0 ? (
                            filteredRetailers.map((user) => (
                              <li
                                key={user.id}
                                className="py-2 flex justify-between items-center"
                              >
                                <label
                                  htmlFor={`user-${user.id}`}
                                  className="flex items-center space-x-2 cursor-pointer w-full"
                                >
                                  <input
                                    id={`user-${user.id}`}
                                    type="radio"
                                    name="selectedUser"
                                    checked={selectedBilledUser === user}
                                    onChange={() => setSelectedBilledUser(user)}
                                    className="cursor-pointer"
                                  />
                                  <div>
                                    <p className="font-medium">
                                      Name: {user.name}
                                    </p>
                                    <p className="text-gray-600">
                                      Username: {user.username}
                                    </p>
                                    <p className="text-gray-600">
                                      Mobile: {user.mobile}
                                    </p>
                                  </div>
                                </label>
                              </li>
                            ))
                          ) : (
                            <h1 className="text-xl">No users found!</h1>
                          )
                        ) : (
                          <h1 className="text-xl">No users found!</h1>
                        )}
                      </ul>
                    </div>
                  </Card>
                </div>
              )}
              <button
                onClick={handleSelectUser}
                className="w-full mt-10 bg-red-600 hover:bg-red-700 py-2 rounded-lg"
              >
                <span className="text-white">
                  {!showRetailer ? "Choose Retailer" : "Checkout"}
                </span>
              </button>

              {/* <Invoice userInformation={userInformation} productList={productList} /> */}
            </aside>
          </div>
        )}
      </div>
      {/* Dialog Component */}
      <Dialog open={showDialog} onClose={handleCloseDialog}>
        <DialogTitle>Invoice</DialogTitle>
        <DialogContent>
          <Invoice invoiceDetails={invoiceData} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DistributorBilling;



const CartItemCard = ({ cartItem, index, removeHandler }) => {
  const { brand, model, condition, serialNumber, variant, retailerPrice } =
    cartItem;

  const image = getImage({ brand, model });
  return (
    <div className="flex flex-wrap items-center py-4 border-b hover:bg-red-700 ">
      <img
        src={image}
        alt={brand}
        className="w-24 md:w-40 h-24 md:h-40 object-contain"
      />
      <div className="flex flex-col font-bold justify-evenly gap-2 w-full flex-1">
        {`${brand} ${model} ${variant}`}
        <span className="text-sm font-normal text-white">{serialNumber}</span>
      </div>
      <div className="h-18 flex items-center ml-left">
        <h1 className="text-xl font-normal">{condition}</h1>
      </div>
      <div className="hidden md:block w-32 px-10">
        <span>₹{retailerPrice}</span>
      </div>
      <div className="flex flex-col md:flex-row gap-2"></div>
      <button
        onClick={() => removeHandler(index)}
        className="text-gray-700 hover:text-red-600 mx-10 hidden md:block"
      >
        <RiDeleteBinLine size={30} color="white" />
      </button>
    </div>
  );
};
